import { createReducer } from '@reduxjs/toolkit';
import { PasswordResetActions } from './actions';
import Constants from './constants';

const initialState = {
  isSubmitting: false,
  sent: false,
  error: null,
};

const ACTION_HANDLER = {
  [PasswordResetActions.requestReset]: (state) => {
    state.isSubmitting = true;
    state.error = null;
  },
  [PasswordResetActions.requestResetSucceeded]: (state) => {
    state.isSubmitting = false;
    state.sent = true;
  },
  [PasswordResetActions.requestResetFailed]: (state, action) => {
    state.isSubmitting = false;
    state.error = action.payload?.error || null;
  },
};

export const passwordResetReducer = createReducer(initialState, ACTION_HANDLER);

export default {
  name: Constants.MODULE_NAME,
  reducer: passwordResetReducer,
};
